import axios from "axios";
import API_URL from "../Config";
import apiClient from "./apiClient";

const publicApiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Cache-Control": "no-cache",
  },
});

const hasValue = (value) =>
  value !== undefined && value !== null && String(value).trim() !== "";

const normalizeAttachmentList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.attachments)) {
    return payload.attachments;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const getDataQr = async (id) => {
  const response = await apiClient.get(`/api/data/${id}/qr`, {
    responseType: "blob",
  });

  return response.data;
};

export const getAttachments = async (dataId) => {
  const response = await apiClient.get(`/api/get_attachments/${dataId}`);
  return normalizeAttachmentList(response.data);
};

export const viewAttachment = async (fileType, dataId) =>
  apiClient.get(`/api/view_attachment/${fileType}/${dataId}`, {
    responseType: "blob",
  });

export const downloadAttachment = async (fileType, dataId) =>
  apiClient.get(`/api/download_attachment/${fileType}/${dataId}`, {
    responseType: "blob",
  });

export const extractFilenameFromHeaders = (
  headers = {},
  fallbackName = "attachment"
) => {
  const contentDisposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";

  const utfFilenameMatch = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i
  );
  if (utfFilenameMatch?.[1]) {
    return decodeURIComponent(utfFilenameMatch[1]);
  }

  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (filenameMatch?.[1]) {
    return filenameMatch[1];
  }

  return fallbackName;
};

export const getPublicDisplayData = async (id, params = {}) => {
  const cleanParams = {};

  if (hasValue(params.lang)) {
    cleanParams.lang = String(params.lang).trim();
  }

  if (hasValue(params.state)) {
    cleanParams.state = String(params.state).trim();
  }

  const response = await publicApiClient.get(`/display_data/${id}`, {
    params: cleanParams,
  });

  return response.data?.data ?? response.data ?? null;
};
